<div class="forge-app">

  <!-- Nav -->
  <nav class="forge-subnav">
    <a routerLink="/blacksmithing" class="forge-subnav__back">← Blacksmithing</a>
    <div class="forge-subnav__links">
      <a routerLink="/blacksmithing/journal" routerLinkActive="forge-subnav__link--active" class="forge-subnav__link">Journal</a>
      <a routerLink="/blacksmithing/my-gallery" routerLinkActive="forge-subnav__link--active" class="forge-subnav__link">My Gallery</a>
    </div>
  </nav>

  <!-- Header -->
  <div class="gallery-hero">
    <div class="gallery-hero__glow"></div>
    <div class="gallery-hero__content">
      <h1>🖼️ My Gallery</h1>
      <p class="gallery-hero__sub" *ngIf="!loading">
        {{ photos.length }} photo{{ photos.length !== 1 ? 's' : '' }} across all forge sessions
      </p>
      <p class="gallery-hero__sub" *ngIf="loading">Loading...</p>
    </div>
    <a routerLink="/blacksmithing/journal" class="btn-secondary gallery-hero__cta">+ Log a Session</a>
  </div>

  <!-- Empty state -->
  <div class="gallery-empty" *ngIf="!loading && !photos.length">
    <div class="gallery-empty__icon">📷</div>
    <h3>No photos yet</h3>
    <p>Add photos to your journal entries to see them here.</p>
    <a routerLink="/blacksmithing/journal" class="btn-forge">Go to Journal</a>
  </div>

  <!-- Photo Grid -->
  <div class="gallery-grid" *ngIf="!loading && photos.length">
    <div
      class="gallery-tile"
      *ngFor="let photo of photos"
      (click)="openLightbox(photo)"
    >
      <img [src]="photo.downloadUrl" [alt]="photo.caption || 'Forge photo'" loading="lazy" />
      <div class="gallery-tile__overlay">
        <span class="gallery-tile__date">{{ formatDate(photo.journalDate) }}</span>
        <span class="gallery-tile__caption" *ngIf="photo.caption">{{ photo.caption }}</span>
      </div>
    </div>
  </div>

  <!-- Lightbox -->
  <div class="lightbox" *ngIf="lightboxPhoto" (click)="closeLightbox()">
    <div class="lightbox__inner" (click)="$event.stopPropagation()">
      <button class="lightbox__close" (click)="closeLightbox()">✕</button>

      <button class="lightbox__nav lightbox__nav--prev" (click)="prevPhoto()" [class.hidden]="lightboxIndex === 0">‹</button>
      <button class="lightbox__nav lightbox__nav--next" (click)="nextPhoto()" [class.hidden]="lightboxIndex === photos.length - 1">›</button>

      <img class="lightbox__img" [src]="lightboxPhoto.downloadUrl" [alt]="lightboxPhoto.caption || ''" />

      <div class="lightbox__meta">
        <span class="lightbox__date">{{ formatDate(lightboxPhoto.journalDate) }}</span>
        <span class="lightbox__caption" *ngIf="lightboxPhoto.caption">{{ lightboxPhoto.caption }}</span>
        <div class="lightbox__actions">
          <a routerLink="/blacksmithing/journal" class="btn-sm">View in Journal</a>
          <button class="btn-sm btn-sm--danger" (click)="deletePhoto(lightboxPhoto)">Delete</button>
        </div>
        <span class="lightbox__counter">{{ lightboxIndex + 1 }} / {{ photos.length }}</span>
      </div>
    </div>
  </div>

</div>
